import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface for debugging; never leave the user on a blank screen.
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-[#101311] text-[#FDFBF7] px-6 text-center" data-testid="app-error-boundary">
          <div className="max-w-md">
            <div className="text-5xl mb-4">🍽️</div>
            <h1 className="font-display font-black text-2xl uppercase text-amber-400">Something went wrong</h1>
            <p className="text-[#FDFBF7]/70 mt-3 text-sm">
              Sorry about that — the page hit an unexpected error. Your information has not been lost.
              Please try again, or call us at <a href="tel:2077738000" className="text-amber-300 font-bold">207-773-8000</a>.
            </p>
            <div className="flex gap-2 justify-center mt-6">
              <button onClick={this.handleReset} className="px-6 py-3 rounded-full border border-emerald-700/50 text-amber-300 font-display font-bold uppercase text-sm">Try Again</button>
              <button onClick={() => { window.location.href = "/"; }} className="px-6 py-3 rounded-full bg-amber-400 text-[#0A2818] font-display font-black uppercase text-sm">Back Home</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
